import { render, staticRenderFns } from "./DownloadAllButton.vue?vue&type=template&id=1ca90f1c&"
import script from "./DownloadAllButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./DownloadAllButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports